import { CrudApiServiceHook } from 'framework/crud';
import { DiffItem } from './types';

export type DifferenceRequestData = {
  oldUrl: string;
  newUrl: string;
  options?: {
    ignoreWhitespace?: boolean;
    ignoreEmptyLines?: boolean;
  };
};

export type DifferenceResponseType = {
  statistics: {
    total: number;
    insertions: number;
    deletions: number;
    changes: number;
    equal: number;
  };
  differences: DiffItem[];
};

// Get file difference by two links
// oldUrl - link to file with prev version
// newUrl - link to file with new version
const useDifferenceByLinks = (useFileDifferenceApi: CrudApiServiceHook) => {
  const { sendPostRequest } = useFileDifferenceApi();

  const getDifference = async (requestData: DifferenceRequestData): Promise<DifferenceResponseType> => {
    const request = await sendPostRequest('/diff', requestData);

    return request.json();
  };

  return {
    getDifference,
  };
};

export default useDifferenceByLinks;
